var VERSION = 1771048312389
export  {
	VERSION
} 
